module.exports = __webpack_public_path__ + "static/media/ubahn-echtzeit~dFaTnXcN.a77acbc2.svg";